<script>
    import { scale } from "svelte/transition";
</script>

<main class="parts"
    in:scale={{ start: 0.8, duration: 1000 }}
    out:scale={{ start: 1.2, duration: 1000 }}
>
    <h3>Présentation</h3>
    <p>
        <span>R</span>eact Native est un framework d'applications mobiles open source
        créé par Facebook. Il est utilisé pour développer des applications pour
        Android, iOS et, moins communémant,
        <a href="https://fr.wikipedia.org/wiki/Universal_Windows_Platform"
            >UWP</a
        >
        en permettant aux développeurs d’utiliser React avec les fonctionnalités
        natives de ces plateformes.
        <br />
        React Native est un framework qui utilise le langage de programmation JavaScript
        et les librairies React développées par Facebook pour développer des interfaces
        webs. Sauf qu’il s’agit désormais de mobile. En d’autres termes, les développeurs
        webs JavaScript peuvent développer des applications mobiles qui ont la performance
        et la fluidité d’applications natives.
        <br />
        Jusqu’alors, les développeurs mobiles devaient programmer deux applications
        distinctes avec des langages très différents (Swift ou objective-C pour iOS,
        Java ou Kotlin pour Android), l’ambition de Facebook était de proposer aux
        développeurs de ne développer qu’une seule base de code pour toutes les plateformes.
        Ceci est rendu possible grâce à un moteur JavaScript qui donne des instructions
        aux instances natives.
    </p>
    <h3>Pour l'histoire</h3>
    <p>
        <span>L</span>orsque Facebook a dévoilé sa librairie React.js durant la JS
        Conf de 2013, on ne pouvait se douter de l’impact de ce projet web sur
        le futur du développement des applications mobiles. L’ambition de
        React.js était alors d’allier simplicité et modularité pour faciliter la
        vie des développeurs d’applications webs en encourageant notamment le
        développement de composants réutilisables.
        <br />
        2 ans plus tard, poussés par l’immense popularité de cette librairie, les
        équipes de Facebook dévoilent un autre projet open source dans sa continuité
        : React Native. L’ambition est cette fois de révolutionner le monde du développement
        mobile avec un framework permettant aux développeurs web de développer des
        applications iOS et Android au rendu natif avec une seule base de code JavaScript.
    </p>
</main>